module.exports = "//public.zight.com/packs/media/images/icons-new-white-1fb7792cb9a451e9432e9907526f6151.svg";